const compUtil = {
    formatterDatePicker(type, val){
        if (type === 'year') {
            return `${val}年`;
        } else if (type === 'month') {
            return `${val}月`;
        }
        else{
            return `${val}日`
        }
    }
}


export default compUtil;

